import { createSelector } from 'reselect'

import selectors from '../../../store/shared/selectors'
import API from '../../../utils/http/api'

// Action Types
const REQUEST = 'steppingblocks/feed/REQUEST'
const SUCCESS = 'steppingblocks/feed/SUCCESS'
const LOAD_MORE_SUCCESS = 'steppingblocks/feed/LOAD_MORE_SUCCESS'
const FAILURE = 'steppingblocks/feed/FAILURE'
const OPEN_MODAL = 'steppingblocks/feed/OPEN_MODAL'
const CLOSE_MODAL = 'steppingblocks/feed/CLOSE_MODAL'
const READ_SUCCESS = 'steppingblocks/feed/READ_SUCCESS'

// Reducer
const initialState = {
  error: null,
  requestStarted: false,
  requestEnded: false,
  results: [],
  isShowingModal: false,
  selectedFeedItem: null,
  page: 1,
  loadMoreDataLength: 0,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        results: payload.clear ? [] : _state.results,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
        page: payload.page,
        loadMoreDataLength: payload.results.length,
      }
    case LOAD_MORE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: _state.results.concat(payload.results),
        page: payload.page,
        loadMoreDataLength: payload.results.length,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case OPEN_MODAL:
      return {
        ..._state,
        isShowingModal: true,
        selectedFeedItem: payload.item,
      }
    case CLOSE_MODAL:
      return {
        ..._state,
        isShowingModal: false,
        selectedFeedItem: null,
      }
    case READ_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
      }
    default:
      return _state
  }
}

// Action Performers
export const closeModal = () => ({ type: CLOSE_MODAL })
export const openModal = item => ({ type: OPEN_MODAL, payload: { item } })

export const performReadFeedItem = postId => async dispatch => {
  dispatch({
    type: REQUEST,
    payload: {
      clear: false,
    },
  })
  try {
    const data = await API.get(`/dashboard/feed/${postId}/read`, {})
    dispatch({
      type: READ_SUCCESS,
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    return error
  }
}

// Selectors
const getFeed = state => state.feed

export const getFeedResults = createSelector(getFeed, feed => feed.results)

const getLoadMoreDataLength = createSelector(getFeed, feed => feed.loadMoreDataLength)

const getIsRequestSuccessful = state => selectors.getIsRequestSuccessful(state, 'feed')

export const getIsEmptyData = createSelector(
  getIsRequestSuccessful,
  getFeedResults,
  (requestSuccess, data) => requestSuccess && data && data.length === 0,
)

export const getIsNoLoadMoreData = createSelector(
  getIsRequestSuccessful,
  getLoadMoreDataLength,
  (requestSuccess, length) => requestSuccess && length === 0,
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/feedDuck.js